import { ReactNode } from "react";

/**
 * Replacements for the simple formatting tags used in translation strings.
 * react-intl v3+ parses tags in every message but no longer injects raw HTML
 * the way v2's FormattedHTMLMessage did, so each tag needs a render function.
 * Registered once on every IntlProvider via `defaultRichTextElements`.
 */
export const intlDefaultRichTextElements = {
  b: (chunks: ReactNode) => <b>{chunks}</b>,
  strong: (chunks: ReactNode) => <strong>{chunks}</strong>,
  i: (chunks: ReactNode) => <i>{chunks}</i>,
  span: (chunks: ReactNode) => <span>{chunks}</span>,
};
